var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkexpression(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 146,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3003 2.11768C66.9606 14.7988 87.6702 -5.78041 102.331 6.90069",
    stroke: "#0061BB",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2241 36.2936C111.777 52.2614 115.198 24.3074 137.177 40.2181",
    stroke: "#0061BB",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8037 17.0636C99.2526 39.2453 112.546 -1.0219 131.054 24.0051",
    stroke: "#FFC469",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9878 62.9556C28.4067 72.3254 39.9074 55.8833 49.7873 66.8638",
    stroke: "#FFC469",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 88.1461C13.7545 84.9493 17.6918 103.583 33.3835 97.9247",
    stroke: "#FF6B00",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.914 111.374C119.577 105.283 116.319 127.996 96.314 119.608",
    stroke: "#9A4A0F",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4679 23.1301C53.4624 9.96665 41.315 25.2396 33.375 13.6704",
    stroke: "#FF6B00",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.332 62.6452C92.328 83.576 119.324 36.5881 146.32 57.5106",
    stroke: "#002756",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 68.8916C24.1092 97.6305 67.0834 65.2941 89.2008 94.0249",
    stroke: "#9A4A0F",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3838 106.158C100.211 125.028 119.013 75.1544 143.831 94.0084",
    stroke: "#FFC469",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4722 117.229C39.6619 145.632 54.4368 106.951 71.9867 121.913",
    stroke: "#002756",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3413 110.5C44.827 115.185 55.501 91.9808 71.9867 96.6739",
    stroke: "#0061BB",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2446 80.4117C115.886 86.5601 127.542 63.2991 144.183 69.4475",
    stroke: "#FF6B00",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55664 48.4432C19.9837 60.4294 41.0615 38.6974 58.4968 50.6917",
    stroke: "#0061BB",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0684 25.1089C33.5145 45.361 67.1408 20.8001 82.3169 49.7761",
    stroke: "#8FCCE6",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.748 137.816C79.4193 157.676 89.9132 119.06 107.971 136.164",
    stroke: "#8FCCE6",
    strokeWidth: 3.09535,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkexpression);
export default __webpack_public_path__ + "static/media/bulkexpression.f7fad035947d2841c839624ad9b14460.svg";
export { ForwardRef as ReactComponent };